import { useDispatch, useSelector } from 'react-redux';
import { Button, IllustrativeIcon, Txt } from '@vst/beam';
import { CheckMark } from '@vst/beam-icons/illustrative-icons';
import { addMonths, setDate } from 'date-fns';
import { Trans, useTranslation } from 'react-i18next';

import { getBillCycleDays, resetUpdateBillCycle, selectUpdateBillCycle } from '@app/redux/updateBillCycle';

import GradientCard from '../gradient-card';
import ProrateNotice from '../prorate-notice';
import Container from './container';

const Success = ({ navigateToBilling }: { navigateToBilling: () => void }) => {
  const { t } = useTranslation(['UpdateBillCycle', 'Global']);
  const dispatch = useDispatch();

  const handleBackClick = () => {
    dispatch(resetUpdateBillCycle());
    dispatch(getBillCycleDays());

    navigateToBilling();
  };

  const { newBillCycleDay, oldBillCycleDay } = useSelector(selectUpdateBillCycle);

  if (!newBillCycleDay) {
    return null;
  }

  const newBillCycleDate = setDate(addMonths(new Date(), 1), newBillCycleDay);

  return (
    <GradientCard>
      <Container>
        <IllustrativeIcon
          data-cy="update-bill-cycle-success"
          name="success-illustration"
          icon={CheckMark}
          color="teal_600"
          style={{ height: '100px', width: '100px' }}
          mt="72px"
          mb="24px"
        />
        <div style={{ textAlign: 'center' }}>
          <Txt variant="heading4" mb="12px">
            {t('success.title')}
          </Txt>
          <Txt variant="bodyLargeRegular" color="subtle">
            <Trans ns="UpdateBillCycle" i18nKey="success.subtitle" values={{ date: newBillCycleDate }} />
          </Txt>
        </div>
        {oldBillCycleDay && <ProrateNotice newBillCycleDay={newBillCycleDay} oldBillCycleDay={oldBillCycleDay} />}
        <Button mb="72px" onClick={handleBackClick}>
          {t('buttons.backToBilling')}
        </Button>
      </Container>
    </GradientCard>
  );
};

export default Success;
